"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var discardSurfaceActionsOption_1 = require("./actions/discardSurfaceActionsOption");
var saveSurfaceActionsOption_1 = require("./actions/saveSurfaceActionsOption");
var SurfaceActionsFull_1 = require("./components/SurfaceActionsFull");
var isSurfaceActionsOptionDirty_1 = require("./utils/isSurfaceActionsOptionDirty");
var owa_controls_feature_flags_1 = require("owa-controls-feature-flags");
var React = require("react");
var ReadSurfaceActionsOption = {
    key: 'readSurfaceActions',
    titleStringKey: 'optionTitle_readSurfaceActions',
    searchTermsStringKey: 'optionTitle_readSurfaceActions',
    fullOptionFormSettings: {
        render: function () { return React.createElement(SurfaceActionsFull_1.default, { isCompose: false }); },
        isDirty: isSurfaceActionsOptionDirty_1.default,
        onSave: saveSurfaceActionsOption_1.default,
        onDiscard: discardSurfaceActionsOption_1.default,
    },
    isHidden: function () { return !owa_controls_feature_flags_1.isControlFeatureEnabled('rp-customSurfaceActions'); },
};
exports.default = ReadSurfaceActionsOption;
//# sourceMappingURL=ReadSurfaceActionsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-surface-actions-option/lib/ReadSurfaceActionsOption.js
// module id = 5243
// module chunks = 2